export default __webpack_public_path__ + "static/media/logo.bd07c666.svg";